/* eslint-disable */

import axios from "axios";
require("../../config/development");
import Vue from "vue";

const state = {
  token: null,
  admin: null,
  succesFlag: false,
  showNotification: false,
  notificationMessage: null,
  admin_partner: null,
  kyc_verification_type: null
};


const getters = {
  admin_partner: state => {
    return state.admin_partner
  },
  kyc_verification_type: state => {
    return state.kyc_verification_type
  },
  admin_token: state => {
    return state.token
  },
};
// actions
const actions = {
  adminLogIn(context, payload) {
    return Vue.vueAuth
      .authenticate(payload.provider, {})
      .then(response => {
        context.commit("SET_TOKEN", response.data);
        context.dispatch("fetchAdminInfo", payload.route);
      })
      .catch(err =>
        context.commit("SHOW_NOTIFICATION", {
          showNotification: true,
          message: err.message,
          succesFlag: false
        })
      );
  },
  adminLogout(context) {
    Vue.vueAuth.logout();
    context.commit("REMOVE_TOKEN");
    return Promise.resolve(true);
  },
  fetchAdminInfo(context, route) {
    let admin_partner = context.rootGetters.admin_partner
    let end_point = Vue.config.EL_DORADO_API_URL
    if (admin_partner == "az"){
      end_point = Vue.config.EL_DORADO_API_URL_BIGCO
    }  

    axios
      .get(
        `${end_point}/admin/adfes433fkdfggs343434/admin.json`
      )
      .then(response => context.commit("SAVE_ADMIN_DETAILS", response.data))
      .catch(() => {
        Vue.vueAuth.logout();
        route.push("/");
        context.commit("SHOW_NOTIFICATION", {
          showNotification: true,
          message: "Unauthorized user",
          succesFlag: false
        });
    });
  }
};

// mutations
const mutations = {
  ["SET_TOKEN"](state, payload) {
    state.token = payload;
  },
  ["REMOVE_TOKEN"](state) {
    state.token = null;
    state.admin = null;
  },
  ["SAVE_ADMIN_DETAILS"](state, payload) {
    state.admin = payload;
  },
  ["SHOW_NOTIFICATION"](state, payload) {
    state.showNotification = payload.showNotification;
    state.notificationMessage = payload.message;
    state.succesFlag = payload.succesFlag;
  },

  set_admin_partner(state, payload) {
    state.admin_partner = payload;
  },
  set_kyc_verification_type(state, payload) {
    state.kyc_verification_type = payload;
  },

  reset_admin_partner(state) {
    state.admin_partner = null
  },

};

export default {
  state,
  actions,
  getters,
  mutations
};
